import { useEffect, useRef } from 'react'
import { useSelector } from 'store/redux.store'
import { useDispatch } from 'react-redux'

import { getIsFrom } from 'modules/user'

export const useFetchIsFrom = () => {
  const { user } = useSelector(state => state)
  const dispatch = useDispatch()
  const isFetchingUserDataIsFrom = useRef<boolean>(false)

  useEffect(() => {
    if (!isFetchingUserDataIsFrom.current && user) {
      dispatch(getIsFrom())
      isFetchingUserDataIsFrom.current = true
    }
  }, [user])
}
